export default __webpack_public_path__ + "static/media/register.202b0bd3.PNG";